module.exports = __webpack_public_path__ + "img/Quality Inspection.08938af1.png";